import Sider from "antd/es/layout/Sider";
import {
  UserDeleteOutlined,
  UserAddOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Divider,
  Input,
  List,
  Row,
  Skeleton,
  Space,
  Statistic,
  Tag,
} from "antd";
import { useEffect, useState } from "react";
import { searchDico } from "../../../../api/Search";

const ListTag = (props) => {
  const { addPerso, persos } = props;

  const renderTag = (p) => {
    return (
      <Tag
        key={p.name}
        style={{ cursor: "pointer" }}
        onClick={() => {
          addPerso(p);
        }}
      >
        {p.name}
      </Tag>
    );
  };

  if (persos.length <= 0) return null;

  return (
    <>
      <Divider plain>Accès rapide</Divider>
      <Space wrap>
        {persos
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((p) => renderTag(p))}
      </Space>
    </>
  );
};

const DicoSearch = (props) => {
  const { selectedText, addDico, openDicoModal } = props;

  const [searchInput, setSearchInput] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [isLoading, setIsloading] = useState(false);

  const loadData = async ({ selection }) => {
    if (selection && selection.length > 0) {
      setIsloading(true);
      // faire la recherche
      const res = await searchDico(selection);
      // console.log(res);
      if (res && res.dicos)
        setSearchResult(res.dicos.map((d) => d.Definitions).flat());
      setIsloading(false);
    }
  };

  const handleChange = async (e) => {
    setSearchInput(e.target.value);
    loadData({ selection: e.target.value });
  };

  const renderRow = (dico) => {
    return (
      <List.Item
        actions={[
          <Button
            size="small"
            onClick={() => {
              addDico({
                word: dico.WordWord,
                definition: dico.definition,
                id: dico.id,
              });
            }}
          >
            Ajouter
          </Button>,
          <Button
            size="small"
            type="link"
            onClick={() => {
              openDicoModal({
                word: dico.WordWord,
                definition: dico.definition,
                id: dico.id,
              });
            }}
          >
            Modifier
          </Button>,
        ]}
      >
        <Skeleton loading={false} title={false} active>
          <List.Item.Meta
            title={<p>{dico.WordWord}</p>}
            description={`${dico.definition}`}
          />
        </Skeleton>
      </List.Item>
    );
  };

  useEffect(() => {
    console.log("SELECTED TEXTE", selectedText);
    setSearchInput(selectedText.selection || "");
    loadData(selectedText);
  }, [selectedText]);

  useEffect(() => {
    if (searchInput.length <= 0) setSearchResult([]);
  }, [searchInput]);

  return (
    <>
      <Input
        allowClear
        addonBefore={<SearchOutlined />}
        onChange={handleChange}
        placeholder="Rechercher un dico"
        value={searchInput}
      />
      <List
        size="small"
        header={
          <Button
            disabled={searchInput.length <= 0}
            onClick={() => {
              openDicoModal({
                word: searchInput,
                context: selectedText.context,
              });
            }}
            type="link"
          >
            Créer le dico
          </Button>
        }
        loading={isLoading}
        itemLayout="vertical"
        dataSource={searchResult}
        renderItem={renderRow}
      />
    </>
  );
};

const SiderEditor = (props) => {
  const {
    addPerso,
    addImage,
    markAsBold,
    markAsDico,
    markAsItalic,
    markAsShouldDelete,
    openPersoModal,
    openDicoModal,
    persos,
    selectedText,
    epLength,
  } = props;

  return (
    <Sider
      style={{
        overflow: "auto",
        height: "85vh",
        position: "fixed",
        right: 15,
        top: 100,
        background: "#FEFEFE",
        padding: 10,
        borderRadius: 5,
      }}
      width={300}
    >
      <Row gutter={5}>
        <Col span={12}>
          <Card bordered={false}>
            <Statistic
              title="Épisode"
              value={epLength}
              valueStyle={{ color: epLength <= 7000 ? "#3f8600" : "#cf1322" }}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card bordered={false}>
            <Statistic
              title="Bulle"
              value={selectedText.context?.length || 0}
              valueStyle={{
                color:
                  (selectedText.context?.length || 0) <= 400
                    ? "#000"
                    : "#cf1322",
              }}
            />
          </Card>
        </Col>
      </Row>

      <Divider plain>Toolbar</Divider>
      <Space wrap>
        <Button
          onClick={() =>
            addPerso({
              name: "Narrateur",
              color: "#E8E8E8",
            })
          }
          icon={<UserDeleteOutlined />}
        >
          Narration
        </Button>
        <Button onClick={openPersoModal} icon={<UserAddOutlined />}>
          Dialogue
        </Button>
        <Button onClick={markAsBold}>Gras</Button>
        <Button onClick={markAsItalic}>Italic</Button>
        <Button onClick={markAsShouldDelete}>À supprimer</Button>
        <Button onClick={addImage}>Ajouter une image</Button>
      </Space>
      <ListTag addPerso={addPerso} persos={persos} />
      <Divider plain>Dico</Divider>

      <DicoSearch
        selectedText={selectedText}
        addDico={markAsDico}
        openDicoModal={openDicoModal}
      />
      <Divider />
    </Sider>
    // <Sider
    //   collapsible
    //   collapsed={collapsed}
    //   onCollapse={(value) => setCollapsed(value)}
    //   style={{
    //     overflow: "auto",
    //     height: "100vh",
    //     position: "fixed",
    //     right: 0,
    //     top: 0,
    //     bottom: 0,
    //   }}
    // >
    //   <div className="demo-logo-vertical" />
    // </Sider>
  );
};

export default SiderEditor;
